export default {
      id: "ar_annuaire_pro-usage",
      viewBox: "0 0 60 55",
      url: "../dist/images/" + "sprite.svg#ar_annuaire_pro-usage",
      toString: function () {
        return this.url;
      }
    }